import { GetterTree } from 'vuex';
import { FormState } from './types';
import { RootState } from './../types';

export enum GetterTypes {
    GET_IS_VISIBLE_FORM = 'getIsVisibleForm',
    GET_WAS_CLICKED_ON_SHOW_RESULT_PAGE = 'getWasClickedOnShowResultPage',
    GET_SHOW_RESULT_PAGE = 'getShowResultPage',
    GET_LABELS = 'getLabels',
    GET_ICONS = 'getIcons',
    GET_IMAGES = 'getImages',
    GET_SETTINGS = 'getSettings',
    GET_INPUTS = 'getInputs',
    GET_DATA = 'getData',
    GET_IS_VALID = 'getIsValid',
    GET_IS_TOUCHED = 'getIsTouched',
    GET_IS_RESETTING_FORM = 'getIsResettingForm',
    GET_HAS_DEFAULT_VALUES = 'getHasDefaultValues',
    GET_FUNNEL_STEP = 'getFunnelStep',
    GET_LOCATION = 'getLocation',
    GET_LOCATION_WITH_HASH = 'getLocationWithHash',
    GET_FUNNEL_STEP_EXTRA = 'getFunnelStepExtra',
    GET_STEPS = 'getSteps',
    GET_URLS = 'getUrls'
}

export type Getters = {
    [GetterTypes.GET_IS_VISIBLE_FORM]: (state: FormState) => boolean,
    [GetterTypes.GET_WAS_CLICKED_ON_SHOW_RESULT_PAGE]: (state: FormState) => boolean,
    [GetterTypes.GET_SHOW_RESULT_PAGE]: (state: FormState) => boolean,
    [GetterTypes.GET_LABELS]: (state: FormState) => Object,
    [GetterTypes.GET_ICONS]: (state: FormState) => Object,
    [GetterTypes.GET_IMAGES]: (state: FormState) => Object,
    [GetterTypes.GET_SETTINGS]: (state: FormState) => Object,
    [GetterTypes.GET_INPUTS]: (state: FormState) => Object,
    [GetterTypes.GET_DATA]: (state: FormState) => Object,
    [GetterTypes.GET_IS_VALID]: (state: FormState) => boolean,
    [GetterTypes.GET_IS_TOUCHED]: (state: FormState) => boolean,
    [GetterTypes.GET_IS_RESETTING_FORM]: (state: FormState) => boolean,
    [GetterTypes.GET_HAS_DEFAULT_VALUES]: (state: FormState) => boolean,
    [GetterTypes.GET_FUNNEL_STEP]: (state: FormState) => Object,
    [GetterTypes.GET_LOCATION]: (state: FormState) => Object,
    [GetterTypes.GET_LOCATION_WITH_HASH]: (state: FormState) => string,
    [GetterTypes.GET_FUNNEL_STEP_EXTRA]: (state: FormState) => Object,
    [GetterTypes.GET_STEPS]: (state: FormState) => Object,
    [GetterTypes.GET_URLS]: (state: FormState) => Object
}

export const getters: GetterTree<FormState, RootState> & Getters = {
    [GetterTypes.GET_IS_VISIBLE_FORM]: state => state.isVisibleForm,
    [GetterTypes.GET_WAS_CLICKED_ON_SHOW_RESULT_PAGE]: state => state.wasClickedOnShowResultButton,
    [GetterTypes.GET_SHOW_RESULT_PAGE]: state => state.showResultPage,
    [GetterTypes.GET_LABELS]: state => state.labels,
    [GetterTypes.GET_ICONS]: state => state.icons,
    [GetterTypes.GET_IMAGES]: state => state.images,
    [GetterTypes.GET_SETTINGS]: state => state.settings,
    [GetterTypes.GET_INPUTS]: state => state.inputs,
    [GetterTypes.GET_DATA]: state => state.data,
    [GetterTypes.GET_IS_VALID]: state => state.isValid,
    [GetterTypes.GET_IS_TOUCHED]: state => state.isTouched,
    [GetterTypes.GET_IS_RESETTING_FORM]: state => state.isResettingForm,
    [GetterTypes.GET_HAS_DEFAULT_VALUES]: state => state.hasDefaultValues,
    [GetterTypes.GET_FUNNEL_STEP]: state => state.funnelStep,
    [GetterTypes.GET_LOCATION]: state => state.location,
    [GetterTypes.GET_LOCATION_WITH_HASH]: (state) => {
        const location = state.location as { href: string, routerLink: string } | null;

        if (location) {
            return location.href + '#/' + location.routerLink;
        } else {
            console.error('Location not available.');
        }

        // Handle the case when location is not available
        return ''; // Or any default value you prefer
    },
    [GetterTypes.GET_FUNNEL_STEP_EXTRA]: state => state.funnelStepExtraData,
    [GetterTypes.GET_STEPS]: state => state.steps,
    [GetterTypes.GET_URLS]: state => state.urls
};